import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const adminApi = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 15000,
  // Send the httpOnly admin_token cookie automatically on every request.
  // CORS allow_credentials=True is already set on the backend.
  withCredentials: true,
});

// Response interceptor — handle 401 globally
// The request interceptor that used to read localStorage and set the
// Authorization header has been removed. The cookie is now attached
// automatically by the browser via withCredentials above.
adminApi.interceptors.response.use(
  (response) => {
    const method = response.config.method?.toLowerCase();
    if (method && ['post', 'put', 'patch', 'delete'].includes(method)) {
      window.dispatchEvent(new Event('admin-actions-changed'));
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 403 && error.response?.data?.detail?.code === 'admin_reauthentication_required') {
      if (window.location.pathname !== '/login') {
        window.location.href = `/login?reauth=1&returnTo=${encodeURIComponent(window.location.pathname)}`;
      }
    }
    if (error.response?.status === 401) {
      // Only redirect if not already on login page to avoid redirect loops.
      // AuthContext.logout() handles clearing local state and cookie (via
      // POST /admin/logout); here we just handle the hard-redirect case for
      // spontaneous 401s (e.g. expired session mid-session).
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default adminApi;
